import React from 'react';
import DataDestinationsPage from 'dataSources/components/DataDestinationsPage';
import { useSelector } from 'react-redux';
import { getAdNetworks, getDataSourcesPage } from '../selector';

export default function AggregatedEtlPage() {
    const props = useSelector(state => getDataSourcesPage(state));
    const adnetworks = useSelector(state => getAdNetworks(state, 'AGGREGATED'));
    const uansData = props.uansData?.filter(uan => Boolean(adnetworks[uan?.adnetworkName]));

    return <DataDestinationsPage redirectPath="react/aggregated-etl" adnetworks={adnetworks} uansData={uansData} />;
}
